import * as React from "react";
import { useExperiment } from "@shared-ui/experiment-context";
import { Experiment } from "./experiment";

export const useFlexibleSearchExperiment = () => {
  const { exposure: flexDateSearchExposure, logExperiment: logFlexDateSearchExperiment } = useExperiment(
    Experiment.Flex_Search_M1_MVP_plus_minus_days_web_Bex
  );

  const { exposure: flexDateContentSearchExposure, logExperiment: logFlexDateContentSearchExposure } = useExperiment(
    Experiment.Flex_Date_M2_duration_month_search_HcomBex_web
  );

  const includeFlexibleCalendarContent = React.useMemo(() => flexDateSearchExposure.bucket > 0, [
    flexDateSearchExposure,
  ]);

  const includeFlexibleDatesContent = React.useMemo(() => flexDateContentSearchExposure.bucket > 0, [
    flexDateContentSearchExposure,
  ]);

  const onOpenDatesField = React.useCallback(() => {
    try {
      logFlexDateSearchExperiment(flexDateSearchExposure);
    } catch {
      // noop
    }

    try {
      logFlexDateContentSearchExposure(flexDateContentSearchExposure);
    } catch {
      // noop
    }
  }, [
    flexDateSearchExposure,
    logFlexDateSearchExperiment,
    logFlexDateContentSearchExposure,
    flexDateContentSearchExposure,
  ]);

  return {
    includeFlexibleCalendarContent,
    includeFlexibleDatesContent,
    onOpenDatesField,
  };
};
